import { RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ } from "../action.js";

export const resetCreateTransactionDetailsandResObj = () => {
  return (dispatch) => {
    dispatch({ type: RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ });
  };
};
